import React, { useEffect } from 'react';
import { useNewReservationSuccess } from './hooks/NewReservationSuccess.hook';
import NewReservationSuccessView from './views/NewReservationSuccessView';
import LoadingComponent from '@/components/general/Loading/LoadingComponent';
import { useLocation } from 'react-router-dom';

const NewReservationSuccessController = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const transactionId = searchParams.get('transaction_id');
  const languageFromPath = searchParams.get('lang');
  const { reservation, isLoading, error, spaceDetails } =
    useNewReservationSuccess(transactionId);

  useEffect(() => {
    if (error) {
      console.log('Error al cargar la reserva:', error);
    }
  }, [error]);

  if (isLoading) {
    console.log('Cargando...');
    return <LoadingComponent loading={isLoading} />;
  }

  return (
    <NewReservationSuccessView
      spaceDetail={spaceDetails}
      reservation={reservation}
      languageFromPath={languageFromPath}
    />
  );
};

export default NewReservationSuccessController;
